<template>
	<div>
		<flCabecalhoForm
			:msg="_traducao('global', 'obrigatorio')"
			color="#1976D2"
			cls="print-titulo-form-40"
			:texto="
				tripulacaoTecnica == '1'
					? _traducao('global', 'tripulacaoTecnica')
					: _traducao('global', 'passageirosDaAeronave')
			"
		/>

		<div class="row">
			<!-- ha passageiros? -->
			<div
				class="col-xs-12 col-md-2 form-group"
				:class="{'has-error': form.erro_existe_passageiro != ''}"
			>
				<label v-if="tripulacaoTecnica == '1'"
					>* _traducao('global', 'haTripulacaoTecnica') }}</label
				>
				<label v-else>* {{ _traducao('global', 'haPassageiros') }}</label>
				<br />
				<div class="btn-group print-button-group" role="group">
					<flSimNao v-model="form.existe_passageiro" :disabled="disabled" />
				</div>
				<p class="help-block" v-show="form.erro_existe_passageiro != ''">
					{{ form.erro_existe_passageiro }}
				</p>
			</div>

			<div
				class="col-xs-8 col-md-2 form-group"
				:class="{'has-error': form.erro_passageiros}"
				v-show="form.existe_passageiro"
			>
				<label>{{ _traducao('global', 'quantos') }}</label>
				<br />
				<a
					href="#"
					class="pass-btn-mais text-center"
					@click.prevent="addPassageiro('+')"
					:class="{disabled: disabled}"
				>
					<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
				</a>
				<a
					href="#"
					class="pass-btn-menos text-center"
					@click.prevent="addPassageiro('-')"
					:class="{disabled: disabled}"
				>
					<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
				</a>
				<input
					type="text"
					:value="form.passageiros"
					style="cursor: default; background: #fff"
					v-mask="'00'"
					disabled="disabled"
					class="form-control text-center input-sm"
				/>

				<p class="help-block" v-show="form.erro_passageiros != ''">
					{{ form.erro_passageiros }}
				</p>
			</div>

			<div
				class="col-xs-8 col-md-2 form-group"
				:class="{'has-error': form.erro_quantidade_estimada_passageiros}"
				v-show="form.existe_passageiro"
				v-if="exibirEstimado"
			>
				<label>
					{{ _traducao('global', 'quantidadeEstimadaPassageiros') }}:</label
				>
				<button
					type="button"
					class="pass-btn-mais-btn btn-link text-center"
					@click.prevent="addQuantidadeEstimada()"
				>
					<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
				</button>
				<button
					type="button"
					:disabled="form.quantidade_estimada_passageiros == 0"
					class="pass-btn-menos-btn btn-link text-center"
					@click.prevent="subQuantidadeEstimada()"
				>
					<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
				</button>
				<input
					type="text"
					:value="form.quantidade_estimada_passageiros"
					style="cursor: default; background: #fff"
					v-mask="'00'"
					disabled="disabled"
					class="form-control text-center input-sm"
				/>
				<p
					class="help-block"
					v-show="form.erro_quantidade_estimada_passageiros != ''"
				>
					{{ form.erro_quantidade_estimada_passageiros }}
				</p>
			</div>

			<div
				class="col-xs-4 col-md-2 form-group"
				v-show="form.existe_passageiro"
				v-if="exibirEstimado"
			>
				<label>{{ _traducao('global', 'grupo') }}: </label>
				<select
					v-model="grupoSelecionado"
					class="form-control input-sm"
					@change="carregarPassageiroGrupo"
				>
					<option :value="null">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="grupo in grupos" :value="grupo.id" :key="grupo.id">
						{{ grupo.descricao }}
					</option>
				</select>
			</div>
		</div>

		<!-- passageiros -->
		<div v-if="form.existe_passageiro">
			<div
				class="col-lg-4"
				v-for="(passageiro, index) in form.passageiro"
				:key="index + 'P'"
			>
				<div class="trecho-borda" style="margin-bottom: 10px">
					<div class="no-print">
						<div class="row">
							<div
								class="col-xs-12 form-group"
								:class="{'has-error': passageiro.nomeErro}"
							>
								<label
									><span class="no-print">* </span>
									{{ _traducao('global', 'nome') }}:</label
								>
								<div style="display: flex">
									<vue-select
										class="form-control input-sm"
										label="nome"
										:filterable="false"
										:disabled="disabled"
										@input="(val) => carregarPassageiro(val, index)"
										:value="passageiro"
										:options="listaPassageiros.lista"
										@open="onOpen"
										@close="onClose"
										@search="(query) => buscaServeSide(query)"
									>
										<template #list-footer>
											<li ref="load" class="loader" v-show="hasNextPage">
												{{ _traducao('global', 'carregandoMaisOpcoes') }}...
											</li>
										</template>
										<template #no-options>
											<li @click.prevent="">
												{{ _traducao('global', 'semPassageiros') }}
											</li>
										</template>
									</vue-select>
									<button
										type="button"
										class="btn btn-sm btn-info"
										style="margin-left: 5px"
										@click="abrirCadastroPassageiro(index)"
									>
										<i class="fa fa-plus fa-fw"></i>
									</button>
									<button
										class="btn btn-sm btn-danger"
										style="margin-left: 5px"
										@click="excluirPassageiro(passageiro)"
									>
										<i class="fa fa-trash fa-fw"></i>
									</button>
								</div>
								<p class="help-block" v-show="passageiro.nomeErro">
									{{ passageiro.nomeErro }}
								</p>
							</div>
						</div>

						<!--SEXO-->
						<div class="row">
							<div
								class="col-xs-6"
								:class="{
									'has-error': passageiro.erroSexo && passageiro.erroSexo != ''
								}"
							>
								<label v-if="tripulacaoTecnica == '1'"
									>* {{ _traducao('global', 'porteTripulante') }}:
									<i
										class="fa fa-fw fa-info-circle"
										v-tooltip="
											'É obrigatório o campo de sexo para definição do peso médio do Tripulante de acordo com o regulamento da ANAC.'
										"
									></i
								></label>
								<label v-else
									>* {{ _traducao('global', 'portePassageiro') }}:
									<i
										class="fa fa-fw fa-info-circle"
										v-tooltip="
											'É obrigatório o campo de porte para definição do peso médio do passageiro de acordo com o regulamento da ANAC.'
										"
									></i
								></label>
								<select
									v-model="passageiro.sexo"
									@change="carregaPesoM(passageiro)"
									class="form-control input-sm"
								>
									<option value>
										{{ _traducao('global', 'escolha').toUpperCase() }}
									</option>
									<option value="m">{{ _traducao('global', 'masc') }}</option>
									<option value="f">{{ _traducao('global', 'fem') }}</option>
									<option v-if="tripulacaoTecnica != '1'" value="c">
										{{ _traducao('global', 'crianca') }}
									</option>
								</select>
								<p class="help-block" v-show="passageiro.erroSexo != ''">
									{{ passageiro.erroSexo }}
								</p>
							</div>
							<!--IDADE-->
							<div class="col-xs-6 form-group">
								<label
									>{{ _traducao('global', 'idade') }}:
									<i
										class="fa fa-fw fa-info-circle"
										v-tooltip="
											'A idade é automaticamente calculada de acordo com a data de nascimento do cadastro de passageiros.'
										"
									></i
								></label>
								<input
									:v-model="calculaIdade(passageiro.data_nascimento)"
									:value="calculaIdade(passageiro.data_nascimento)"
									disabled
									type="text"
									class="form-control input-sm"
								/>
							</div>
						</div>
						<!-- peso -->
						<div class="row">
							<div class="col-xs-6 form-group">
								<label
									>* {{ _traducao('global', 'pesoMedio') }}:
									<i
										class="fa fa-fw fa-info-circle"
										v-tooltip="
											'O campo de peso médio é baseado nos regulamentos vigentes. Homem 80 kg (176 lb), Mulher adulta 70 kg (154 lb), Criança entre (2 e 12 anos) 30 kg (66 lb).'
										"
									></i>
								</label>
								<money
									:value="passageiro.pesoMedio"
									disabled
									v-bind="_vpercem(2)"
									class="form-control input-sm"
								></money>
							</div>
							<div
								class="col-xs-6 form-group"
								:class="{'has-error': passageiro.pesoPassageiroErro}"
							>
								<label
									><span class="no-print">*</span>
									{{ _traducao('global', 'pesoReal') }}:</label
								>
								<small class="solicitacao-previsao">(Kg)</small>
								<money
									v-model="passageiro.peso"
									v-bind="_vpercem(2)"
									class="form-control input-sm"
									:disabled="disabled"
								></money>
								<p
									class="help-block"
									style="position: absolute"
									v-show="passageiro.pesoPassageiroErro"
								>
									{{ passageiro.pesoPassageiroErro }}
								</p>
							</div>
						</div>

						<div class="row">
							<div
								class="col-xs-6 form-group"
								:class="{
									'has-error': passageiro.cpfErro,
								}"
							>
								<label
									><span></span>
									{{ _traducao('menuAGnovoUsuario', 'menuAGcpf') }}:</label
								>
								<!-- <input
										type="text"
										v-model="passageiro.cpf"
										v-mask="_vdocumento"
										class="form-control form-group input-sm"
										@blur="$emit('validar-cpf-passageiro', index, passageiro)"
									/> -->
								<vue-select
									class="form-control input-sm"
									label="cpf"
									:filterable="false"
									:disabled="disabled"
									@input="(val) => carregarPassageiro(val, index)"
									:value="passageiro"
									:options="listaPassageiros.lista"
									@open="onOpen"
									@close="onClose"
									@search="(query) => buscaServeSide(query)"
								>
									<template #list-footer>
										<li ref="load" class="loader" v-show="hasNextPage">
											{{ _traducao('global', 'carregandoMaisOpcoes') }}...
										</li>
									</template>
									<template #no-options>
										<li @click.prevent="">
											{{ _traducao('global', 'semPassageiros') }}
										</li>
									</template>
								</vue-select>
								<p class="help-block" v-show="passageiro.cpfErro">
									{{ passageiro.cpfErro }}
								</p>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-6 form-group" v-if="exibeOutro">
								<label>{{ nomeOutroDocumento }}:</label>
								<input
									v-model="passageiro.outro"
									class="form-control input-sm"
									:disabled="disabled"
								/>
								<p
									class="help-block"
									style="position: absolute"
									v-show="passageiro.outroErro"
								>
									{{ passageiro.outroErro }}
								</p>
							</div>
							
						</div>
						<div class="row">
							<div class="col-xs-6 form-group">
								<label>
									<i
										v-show="passageiro.estrangeiro"
										style="font-size: 12px"
										v-tooltip="
											_traducao(
												'global',
												'oCampoDePassaporteEObrigatorioParaUmEstrangeiro'
											)
										"
										class="fa fa-info-circle text-info"
										aria-hidden="true"
									></i>
									{{ _traducao('global', 'eEstrangeiro') }}?
								</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<flSimNao
										v-model="passageiro.estrangeiro"
										@change="limparErrosAoAlterarEstrangeiro(passageiro)"
									/>
								</div>
							</div>
							<div class="col-xs-6 form-group">
								<input-text
									v-show="passageiro.estrangeiro || flagCompleto"
									class="form-group"
									:label="_traducao('global', 'passaporte')"
									v-model="passageiro.passaporte"
									:mensagem-erro="passageiro.passaporteErro"
									:obrigatorio="passageiro.estrangeiro"
								/>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-6 form-group">
								<input-text
									v-if="flagCompleto"
									:label="_traducao('global', 'matricula')"
									v-model="passageiro.matricula"
								/>
							</div>
							<div class="col-xs-6 form-group">
								<input-text
									v-if="flagCompleto"
									label="RG"
									v-model="passageiro.rg"
								/>
							</div>
						</div>

						<!-- telefone -->
						<div class="row">
							<div class="col-md-6 form-group">
								<label>{{ _traducao('global', 'telefone') }}:</label>
								<input
									:disabled="disabled"
									type="text"
									v-model="passageiro.telefone"
									v-mask="_vtelefone"
									class="form-control"
								/>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-xs-12">
							<label>{{ _traducao('global', 'atencaoEspecial') }}: </label>
							<div>
								<div style="display: flex; flex-direction: row">
									<select
										class="form-control input-xs"
										style="width: 193px"
										v-model="atencaoSelecionada[index]"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											:value="atencao_especial.id"
											v-for="atencao_especial in listaAtencaoEspecial"
											:key="'atencao-especial-' + atencao_especial.id"
										>
											{{ atencao_especial.descricao }}
										</option>
									</select>
									<span class="input-group-btn">
										<button
											class="btn btn-sm btn-info"
											type="button"
											@click="clickAddAtencao(passageiro, atencaoSelecionada[index])"
										>
											ADD<i class="fa fa-arrow-down fa-fw"></i>
										</button>
									</span>
									<label style="margin-bottom: 6px">&nbsp;</label>
									<br />
								</div>
							</div>
						</div>
					</div>
					<br>

					<div class="row">
						<div class="col-xs-12">
							<span
								v-for="(att, indx) in passageiro.atencao_especial"
								style="margin-top: 15px"
								@click="removeAtencaoEspecial(passageiro, att, indx)"
							>
								<span class="label-click">
									{{ att.descricao }}
								</span>
							</span>
						</div>
					</div>

					<div class="no-print">
						<div class="row">
							<input-select
								class="col-xs-6"
								v-if="flagSimples || flagCompleto"
								:label="_traducao('menuAGcadAluno', 'empresa')"
								:opcoes-objeto="orgaosApoiados"
								label-option="descricao"
								campo-valor="id"
								:disabled="disabled"
								v-model="passageiro.orgao"
							/>
							<!--Cidade-->
							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>{{ _traducao('global', 'cidade') }}:</label>
								<input
									:disabled="disabled"
									type="text"
									v-model="passageiro.cidade"
									class="form-control input-sm"
								/>
							</div>
						</div>

						<!--Equipe titular-->
						<div class="row">
							<!-- cargo -->
							<div
								class="col-xs-6 form-group"
								v-if="flagSimples || flagCompleto"
							>
								<label
									>{{ _traducao('menuRGordemmissao', 'menuOMcargo') }}:</label
								>
								<input
									:disabled="disabled"
									type="text"
									v-model="passageiro.cargo"
									class="form-control input-sm"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12 form-group" v-if="flagCompleto">
								<label>Observação:</label>
								<input
									:disabled="disabled"
									type="text"
									v-model="passageiro.observacao"
									class="form-control input-sm"
								/>
							</div>
							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Peso Bagagem de Mão:</label>
								<small class="solicitacao-previsao">(Kg)</small>
								<money
									v-model="passageiro.peso_bagagem_mao"
									v-bind="_vpercem(2)"
									class="form-control input-sm"
									:disabled="disabled"
								></money>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Peso Bagagem do Porão:</label>
								<small class="solicitacao-previsao">(Kg)</small>
								<money
									v-model="passageiro.peso_bagagem_porao"
									v-bind="_vpercem(2)"
									class="form-control input-sm"
									:disabled="disabled"
								></money>
							</div>
							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Valor Passagem:</label>
								<money
									v-model="passageiro.passagem"
									v-bind="_vpercem(2)"
									class="form-control input-sm"
									:disabled="disabled"
								></money>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Hospedagem:</label>
								<div>
									<flSimNao
										:disabled="disabled"
										v-model="passageiro.hospedagem"
									/>
								</div>
							</div>
							<div class="col-xs-6 form-group" v-if="flagCompleto">
								<label>Passageiro em Stand-By:</label
								><i
									class="fa fa-fw fa-info-circle"
									v-tooltip="
										'O passageiro em Stand-By está aguardando vaga disponível para embarcar no voo solicitado.'
									"
								></i>
								<div>
									<flSimNao :disabled="disabled" v-model="passageiro.standby" />
								</div>
							</div>
						</div>

						<div class="row">
							<div
								class="col-xs-12"
								:class="{'has-error': passageiro.trechoErro}"
							>
								<label v-if="tripulacaoTecnica == '1'"
									>{{ _traducao('global', 'desmarqueTrechosTrip') }}:</label
								>
								<label v-else
									>{{ _traducao('global', 'desmarqueTrechosPass') }}:</label
								>
								<table
									class="table table-condensed"
									style="margin-bottom: 0px"
									v-if="possuiTrechos"
								>
									<tbody>
										<tr
											v-for="(trecho, idx) in passageiro.trecho"
											style="vertical-align: middle; cursor: pointer"
											@click="!disabled ? atualizarTrecho(trecho) : ''"
											:key="idx + 'T'"
											:style="{
												'background-color': trecho.esta
													? '#a9d796'
													: passageiro.trechoErro
													? '#C9302C'
													: '',
												'color': trecho.esta
													? 'black'
													: passageiro.trechoErro
													? 'white'
													: 'black'
											}"
										>
											<td class="text-left" style="width: 50%">
												<small style="font-size: 10px; font-weight: 700">
													{{
														trecho.pais_partida
															? trecho.pais_partida.descricao
															: ''
													}} </small
												><br />
												<small style="font-size: 10px; font-weight: 700">
													{{
														trecho.designativo_partida
															? trecho.designativo_partida.cidade
															: ''
													}}
													-
													{{
														trecho.estado_partida
															? trecho.estado_partida.nome
															: ''
													}} </small
												><br />
												<small style="font-size: 10px; font-weight: 700">
													({{
														trecho.designativo_partida
															? trecho.designativo_partida.sigla
															: ''
													}})
													{{
														trecho.designativo_partida
															? trecho.designativo_partida.local
															: ''
													}}
													<br />
													{{ trecho.descricao_partida }}
												</small>
											</td>
											<td class="text-center" style="vertical-align: middle">
												<i
													class="fa fa-arrow-right"
													style="font-size: 12px"
													aria-hidden="true"
												></i>
												<i
													class="fa fa-chevron-down"
													v-if="idx < passageiro.trecho.length - 1"
													style="font-size: 10px"
													aria-hidden="true"
												></i>
											</td>
											<td
												class="text-right"
												style="width: 50%; vertical-align: middle"
											>
												<small style="font-size: 10px; font-weight: 700">
													{{
														trecho.pais_destino
															? trecho.pais_destino.descricao
															: ''
													}} </small
												><br />
												<small
													style="font-size: 10px; font-weight: 700"
													v-if="
														trecho.estado_destino && trecho.estado_destino.nome
													"
												>
													{{ trecho.estado_destino.nome }}
													-
													{{ trecho.designativo_destino.cidade }} </small
												><br />
												<small
													style="font-size: 10px; font-weight: 700"
													v-if="
														!trecho.nao_tem_aerodromo &&
														trecho.designativo_destino &&
														trecho.designativo_destino.sigla
													"
												>
													({{ trecho.designativo_destino.sigla }})
													{{ trecho.designativo_destino.local }}
													{{ trecho.descricao_destino }}
												</small>
												<small
													style="font-size: 10px; font-weight: 700"
													v-if="trecho.nao_tem_aerodromo"
												>
													<br />
												</small>
											</td>
										</tr>
									</tbody>
									<p class="help-block" v-show="passageiro.trechoErro">
										{{ passageiro.trechoErro }}
									</p>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal ref="formCadastroPassageiro">
			<div class="row">
				<div class="col-xs-12">
					<h4 v-if="tripulacaoTecnica == '1'">
						{{ _traducao('global', 'cadastroTripulanteTecnico').toUpperCase() }}
						<button
							type="button"
							class="close"
							@click="$refs.formCadastroPassageiro.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<h4 v-else>
						{{ _traducao('global', 'cadastroPassageiros').toUpperCase() }}
						<button
							type="button"
							class="close"
							@click="$refs.formCadastroPassageiro.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<hr />
				</div>
				<flFormCadastroPassageiro
					:is-not-modal="false"
					@passageiro-salvo="carregarPassageiroRecemSalvo"
				/>
			</div>
		</modal>
	</div>
</template>
<script>
import flFormCadastroPassageiro from '@/modules/layout/admin-geral/cadastro-passageiros/form/main.vue'

export default {
	components: {flFormCadastroPassageiro},
	props: {
		form: {
			type: Object,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		possuiTrechos: {
			type: Boolean,
			default: true
		},
		exibirEstimado: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			exibeOutro: false, 
			nomeOutroDocumento: '',
			passageirosExcluidos: [],
			listaAtencaoEspecial: [],
			indexCadastro: null,
			orgaosApoiados: [],
			grupos: [],
			grupoSelecionado: null,
			listaPassageiros: [],
			passageiros: [],
			flagComponente: $cliente.get('componente_passageiro_solicitacao'),
			observer: null,
			limit: 10,	
			search: '',
			timeBusca: null,
			atencaoSelecionada: [],
			tripulacaoTecnica: false
		}
	},
	watch: {
		'form.existe_passageiro': function (val) {
			if (val) {
				if (this.form.id == 0) {
					this.addPassageiro('+')
				}
			} else {
				this.form.passageiro = []
				this.form.passageiros = 0
			}
		},
		'search'(novo, antigo) {
			if (novo != antigo) {
				clearTimeout(this.timeBusca)
				this.timeBusca = setTimeout(this.carregarListaPassageiros, 400)
			}
		}
	},
	mounted() {
		this.carregaPassageiros()
		this.carregarGrupos()
		this.carregarListaPassageiros()
		this.carregarListaAtencaoEspecial()
		this.observer = new IntersectionObserver(this.infiniteScroll)
		this.parametros()
	},
	methods: {
		carregaPassageiros() {
			if (this.form.quantidade_estimada_passageiros > 0) {
				this.form.existe_passageiro = true
			}
		},
		addQuantidadeEstimada() {
			this.form.quantidade_estimada_passageiros =
				Number(this.form.quantidade_estimada_passageiros) + 1
		},
		subQuantidadeEstimada() {
			if (Number(this.form.quantidade_estimada_passageiros) > 0) {
				this.form.quantidade_estimada_passageiros =
					Number(this.form.quantidade_estimada_passageiros) - 1
			}
		},
		buscaServeSide(search) {
			this.search = search
		},
		async onOpen() {
			if (this.hasNextPage) {
				await this.$nextTick()
				this.observer.observe(this.$refs.load[0])
			}
		},
		onClose() {
			this.observer.disconnect()
		},
		async infiniteScroll([{isIntersecting, target}]) {
			if (isIntersecting) {
				const ul = target.offsetParent
				const scrollTop = target.offsetParent.scrollTop
				const retorno = await new Promise((resolve) => {
					const page = Number(this.listaPassageiros.pagination.page) + 1
					let rota = `/Passageiro/lista?page=${page}`
					if (this.search) {
						rota += `&search=${this.search}`
					}
					this._httpGet(rota, (retorno) => {
						if (retorno._request && retorno._status) {
							retorno.lista.map((passageiro) => {
								passageiro.id_passageiro = passageiro.id
								passageiro.orgao = passageiro.id_orgao_apoiado
								passageiro.peso = parseFloat(passageiro.peso, 2)
								return passageiro
							})
							resolve(retorno)
						}
					})
				})
				this.listaPassageiros.lista = [
					...this.listaPassageiros.lista,
					...retorno.lista
				]
				this.listaPassageiros.pagination = retorno.pagination
				await this.$nextTick()
				ul.scrollTop = scrollTop
			}
		},
		atualizarTrecho(trecho) {
			trecho.esta = !trecho.esta
			this.$forceUpdate()
		},
		abrirCadastroPassageiro(index) {
			this.$refs.formCadastroPassageiro.modalShow(80)
			this.indexCadastro = index
		},

		carregarPassageiroRecemSalvo(passageiro) {
			passageiro.trecho = []
			if (this.possuiTrechos) {
				this.form.trecho.forEach((trecho, indexFormTrecho) => {
					passageiro.trecho.push({...trecho, esta: true})
				})
			}
			this.$refs.formCadastroPassageiro.modalHide()
			passageiro.peso = parseFloat(passageiro.peso).toFixed(2)
			this.carregaPesoM(passageiro)
			this.listaPassageiros.lista.push(passageiro)
			this.form.passageiro[this.indexCadastro] = passageiro
			this.form.passageiro[this.indexCadastro].orgao =
				passageiro.id_orgao_apoiado
		},

		carregarPassageiro(val, index) {
			val.trecho = []
			if (!val) {
				if (this.form.passageiro[index]) {
					this.$set(this.form.passageiro, index, this.passageiroLimpo())
				}
				return
			}

			if (this.form.passageiro.length > 0) {
				if (
					this.form.passageiro.find((pass) => {
						return val.id_passageiro == pass.id_passageiro
					})
				) {
					window.bus.$emit('exibir-notificacao', {
						type: 'danger',
						text: this._traducao('global', 'voceJaAddEssePerfil')
					})
				} else {
					this.$set(this.form.passageiro, index, val)
					if (!val.trecho || !val.trecho.length) {
						val.trecho = []
					}
					if (this.possuiTrechos) {
						this.form.trecho.forEach((trecho, indexFormTrecho) => {
							val.trecho.push({...trecho, esta: true})
						})
					}
				}
			}
		},

		clickAddAtencao(passageiro, itemId) {

			if(passageiro.nome == null || passageiro.nome == ''){
				window.bus.$emit('exibir-notificacao', {
						text: 'Selecione o passageiro primeiro',
						type: 'danger'
					})

					return false
			}

			const passageiroObj = this.form.passageiro.find(
				(p) => p.nome === passageiro.nome
			)
			const selectedItem = this.listaAtencaoEspecial.find(
				(item) => item.id === itemId
			)
			const existingItemIndex = passageiroObj.atencao_especial.findIndex(
				(item) => item.id === itemId
			)
			if (existingItemIndex !== -1) {
				const existingItem = passageiroObj.atencao_especial[existingItemIndex]
				if (existingItem.excluir) {
					existingItem.excluir = false
					window.bus.$emit('exibir-notificacao', {
						text: this._traducao('global', 'atencaoAdd'),
						type: 'success'
					})
				} else {
					window.bus.$emit('exibir-notificacao', {
						text: this._traducao('global', 'voceJaAddEssePerfil'),
						type: 'danger'
					})
				}
			} else {
					passageiroObj.atencao_especial.push(selectedItem)
			}
		},

		removeAtencaoEspecial(passageiro, item, index) {
			item.excluir = true
			const passageiroObj = this.form.passageiro.find(
				(p) => p.nome === passageiro.nome
			)

			passageiroObj.atencao_especial.splice(index, 1)
		},

		calculaIdade(dateString) {
			var idade
			if (dateString == null || dateString == '0000-00-00') {
				idade = 'N/A'
			} else {
				var nascimento = new Date(dateString)
				var hoje = new Date()
				idade = hoje.getFullYear() - nascimento.getFullYear()
				var diferencaMes = hoje.getMonth() - nascimento.getMonth()
				if (
					diferencaMes < 0 ||
					(diferencaMes === 0 && hoje.getDate() < nascimento.getDate())
				) {
					idade--
				}
			}
			return idade
		},

		carregaPesoM(item) {
			switch (item.sexo) {
				case 'c':
					item.pesoMedio = 30
					break
				case 'f':
					item.pesoMedio = 70
					break
				case 'm':
					item.pesoMedio = 80
					break
				default:
					item.pesoMedio = 0
			}
		},

		carregarListaAtencaoEspecial() {
			this._httpGet('/Tipo_atencao_especial/lista', (retorno) => {
				if (retorno._request && retorno._status) {
					this.listaAtencaoEspecial = retorno.lista
					this.listaAtencaoEspecial.forEach((att) => {
						att.excluir = false
					})
				}
			})
		},

		carregarListaPassageiros() {
			let rota = '/Passageiro/lista'
			if (this.search) {
				rota += `?search=${this.search}`
			}
			this._httpGet(rota, (retorno) => {
				if (retorno._request && retorno._status) {
					retorno.lista.map((passageiro) => {
						passageiro.id_passageiro = passageiro.id
						passageiro.orgao = passageiro.id_orgao_apoiado
						passageiro.standby = false
						this.carregaPesoM(passageiro)
						passageiro.peso = parseFloat(passageiro.peso, 2)
						passageiro.atencao_especial.forEach((att) => {
							att.excluir = false
						})
						// passageiro.cpf = passageiro.cpf.replace('-', '').replace('.', '')
						return passageiro
					})
					this.listaPassageiros = retorno
				}
			})
		},

		carregarPassageiroGrupo() {
			this._httpGet('/Passageiro/grupo/' + this.grupoSelecionado, (retorno) => {
				if (retorno._request && retorno._status) {
					this.form.passageiro = retorno.lista
					this.form.passageiro.map((passageiro) => {
						passageiro.id_passageiro = passageiro.id
						passageiro.orgao = passageiro.id_orgao_apoiado
						passageiro.peso = parseFloat(passageiro.peso, 2)
						this.carregaPesoM(passageiro)
						passageiro.trecho = []
						if (this.possuiTrechos) {
							this.form.trecho.forEach((trecho) => {
								passageiro.trecho.push({
									...trecho,
									...passageiro.trecho,
									esta: true
								})
							})
						}
					})
					this.form.passageiros = this.form.passageiro.length
				}
			})
		},

		carregarGrupos() {
			this._httpGet('/Grupo_passageiro/lista', (retorno) => {
				if (retorno._request && retorno._status) {
					this.grupos = retorno.lista
				}
			})
		},

		// ADD PASSAGEIROS CASO HAJA
		addPassageiro(sinal) {
			if (sinal == '+') {
				let passageiro = this.passageiroLimpo()

				if (this.possuiTrechos) {
					for (var i in this.form.trecho) {
						passageiro.trecho.push({...this.form.trecho[i], esta: true})
					}
				}

				this.form.passageiro.push(passageiro)
			}

			if (sinal == '-') {
				this.passageirosExcluidos.push({
					...this.form.passageiro[this.form.passageiro.length - 1]
				})
				delete this.form.passageiro[this.form.passageiro.length - 1].trecho
				this.passageirosExcluidos = this.passageirosExcluidos.filter(
					(pass) => pass.id != pass.id_passageiro
				)
				this.form.passageiro.splice(this.form.passageiro.length - 1, 1)

				window.bus.$emit('lista-excluir-passageiros', this.passageirosExcluidos)
			}

			this.form.passageiros = this.form.passageiro.length
		},

		excluirPassageiro(passageiro) {
			passageiro.trecho = []
			let index = this.form.passageiro.findIndex(
				(pass) => pass.id == passageiro.id
			)
			this.passageirosExcluidos.push(this.form.passageiro[index])
			this.passageirosExcluidos = this.passageirosExcluidos.filter(
				(pass) => pass.id != pass.id_passageiro
			)
			this.form.passageiro.splice(index, 1)

			window.bus.$emit('lista-excluir-passageiros', this.passageirosExcluidos)

			this.form.passageiros = this.form.passageiro.length
		},

		parametros() {
			this._getParametro(145).then((valor) => (this.tripulacaoTecnica = valor))
			this._getParametro(3).then((valor) => {
				if (Number(valor)) {
					this.exibeOutro = Number(valor)
					this._getParametro(4).then((val) => {
						if (typeof val === 'string') {
							this.nomeOutroDocumento = val.capitalizeFirst()
						}
					})
				}
			})
		},

		passageiroLimpo() {
			return {
				id: 0,
				nome: '',
				nomeErro: '',
				orgao: '',
				orgaoErro: '',
				cargo: '',
				cargoErro: '',
				cpf: '',
				cpfErro: '',
				rg: '',
				matricula: '',
				passaporte: '',
				passaporteErro: '',
				estrangeiro: false,
				telefone: '',
				telefoneErro: '',
				hospedagem: false,
				standby: false,
				atencao_especial: [],
				trecho: [],
				trechoErro: '',
				erroSexo: '',
				pesoPassageiroErro: '',
				atencaoSelecionada: [],
			}
		},

		limparErrosAoAlterarEstrangeiro(passageiro) {
			if (passageiro.estrangeiro && passageiro.cpfErro && !passageiro.cpf) {
				passageiro.cpfErro = ''
			}
			if (!passageiro.estrangeiro && passageiro.passaporteErro) {
				passageiro.passaporteErro = ''
			}
		}
	},
	computed: {
		hasNextPage() {
			return (
				this.listaPassageiros.pagination.page <
				this.listaPassageiros.pagination.pages
			)
		},
		flagSimples() {
			return this.flagComponente === 'simples'
		},
		flagCompleto() {
			return this.flagComponente === 'completo'
		},

		atencaoNaoExcluido() {
			return this.form.passageiro.atencao_especial.filter((att) => !att.excluir)
		}
	},
	created() {
		this._providerOrgaoApoiado((lista) => {
			this.orgaosApoiados = lista
		})
	}
}
</script>
<style>
.loader {
	text-align: center;
	color: #bbbbbb;
}
</style>